import { CollapsiblePanel, Panel } from "../../../widgets";
import { ControlType, Property, PropertyType } from "../../../base/types";

import { EntityDocumentChecklists } from "./components/EntityDocumentChecklists";
import { FC } from "react";
import { IControlAttributes } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useGetProperties } from "../../../base/hooks";

export const EntityDocumentChecklistComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    const entityId: string | undefined = properties[Property.EntityId];
    const entity: string | undefined = properties[Property.Entity]
    const title: string | undefined = properties[Property.Title]
    const headerClass: string | undefined = properties[Property.HeaderClass]
    const collapsible: boolean | undefined = properties[Property.Collapsible]
    const relativePath: string | undefined = properties[Property.RelativePath]

    if (collapsible) {
        return (
            <CollapsiblePanel
                eventKey="checklist"
                header={title}
                icon="FactCheckOutlined"
                headerClass={headerClass}
                className={className}>
                <EntityDocumentChecklists
                    entityId={entityId}
                    entity={entity}
                    relativePath={relativePath} />
            </CollapsiblePanel>
        )
    }

    return (
        <Panel
            header={title}
            icon="FactCheckOutlined"
            headerClass={headerClass}
            className={className}>
            <EntityDocumentChecklists
                entityId={entityId}
                entity={entity}
                relativePath={relativePath} />
        </Panel>)
}

Registry.addControl({
    id: "984cd3e4-e23e-4ee2-80b6-f1462cadbb32",
    name: "Entity Document Checklist",
    type: ControlType.EntityDocumentChecklist,
    properties: [
        { id: Property.Title, name: 'Title', type: PropertyType.String },
        { id: Property.Entity, name: 'Entity', type: PropertyType.Entity },
        { id: Property.EntityId, name: 'EntityId', type: PropertyType.String },
        { id: Property.RelativePath, name: 'Relative Path', type: PropertyType.String },
        { id: Property.Collapsible, name: 'Collapsible', type: PropertyType.Boolean },
        { id: Property.HeaderClass, name: 'Header Class', type: PropertyType.String },
    ],
    component: EntityDocumentChecklistComponent
})
